import Flickity from "flickity";
import "flickity-imagesloaded";
import $ from "jquery";
import Swiper from "swiper";

function equalHeights(elm) {
    let maxHeight = 0;
    const items = (typeof elm == "string") ? document.querySelectorAll(elm) : elm;

    items.forEach(el => {
        maxHeight = Math.max(el.clientHeight, maxHeight);
    });

    items.forEach(el => {
        el.style.height = `${maxHeight}px`;
    });

    return `${maxHeight}px`;
}

function setHeight(sliderInstance, sliderItems) {
    if (!window.acf) {
        equalHeights(sliderItems)
    } else {
        setTimeout(() => {
            let equalHeightValue = equalHeights(sliderItems)
            sliderInstance.querySelector(".flickity-viewport").style.height = equalHeightValue
        }, 100);
    }
}

export default function Sliders() {
    $(initialiseAllSliders);
}

var isInitialised = false;

export function initialiseAllSliders() {
    if (isInitialised) {
        return;
    }

    isInitialised = true;

    if ($(".hero-slider").length) {
        const sliders = document.querySelectorAll('.hero-slider');

        sliders.forEach(slider => {
            let hero_slider_flkty = null,
                equalHeightClass = null


            if (!window.acf) equalHeightClass = slider.querySelectorAll(".slide-item")
            else {
                equalHeightClass = Array.from(slider.querySelectorAll(".slide-item")).map(item => item.parentElement)
            }

            hero_slider_flkty = new Flickity(slider, {
                cellAlign: "left",
                wrapAround: false,
                draggable: window.acf ? false : true,
                contain: true,
                pageDots: true,
                prevNextButtons: false,
                autoPlay: 5000,
                on: {
                    ready: () => {
                        setHeight(slider, equalHeightClass)
                    },
                    resize: () => {
                        setHeight(slider, equalHeightClass)
                    }
                },
            });

            if (window.acf) {
                setTimeout(() => {
                    hero_slider_flkty_flkty.resize();
                }, 500);
            }

            window.addEventListener("resize", () => {
                if (!window.acf) {
                    equalHeightClass.forEach((sliderItem) => {
                        sliderItem.style.height = "auto";
                    });
                }

                hero_slider_flkty.resize()
            })
        });
    }

    if ($(".card-flkty").length) {
        const sliders = document.querySelectorAll('.card-flkty');

        sliders.forEach(slider => {
            let card_flkty = null,
                cardBody = slider.querySelectorAll('.card-body'),
                equalHeightClass = null,
                prevSlideButton = slider.parentElement.parentElement.querySelector(".card-prev"),
                nextSlideButton = slider.parentElement.parentElement.querySelector(".card-next");


            if (!window.acf) equalHeightClass = slider.querySelectorAll(".card-item")
            else {
                equalHeightClass = Array.from(slider.querySelectorAll(".card-item")).map(item => item.parentElement)
            }

            if (cardBody && cardBody.lengh) equalHeights(cardBody)

            card_flkty = new Flickity(slider, {
                cellAlign: "left",
                wrapAround: false,
                draggable: window.acf ? false : true,
                contain: true,
                pageDots: false,
                prevNextButtons: false,
                watchCSS: true,
                on: {
                    ready: () => {
                        setHeight(slider, equalHeightClass)
                    },
                    resize: () => {
                        setHeight(slider, equalHeightClass)
                    }
                },
            });

            if (prevSlideButton) {
                prevSlideButton.addEventListener("click", () => {
                    card_flkty.previous();
                })
            }

            if (nextSlideButton) {
                nextSlideButton.addEventListener("click", () => {
                    card_flkty.next();
                })
            }

            if (window.acf) {
                setTimeout(() => {
                    card_flkty.resize();
                }, 500);
            }

            window.addEventListener("resize", () => {
                if (!window.acf) {
                    equalHeightClass.forEach((sliderItem) => {
                        sliderItem.style.height = "auto";
                    });
                }

                card_flkty.resize()
            })
        });
    }

    if ($(".courses-slider").length) {
        const sliders = document.querySelectorAll('.courses-slider');

        sliders.forEach(slider => {
            let courses_flkty = null,
                cardBody = slider.querySelectorAll('.card-body'),
                equalHeightClass = null;


            if (!window.acf) equalHeightClass = slider.querySelectorAll(".course-item")
            else {
                equalHeightClass = Array.from(slider.querySelectorAll(".course-item")).map(item => item.parentElement)
            }

            if (cardBody && cardBody.lengh) equalHeights(cardBody)

            courses_flkty = new Flickity(slider, {
                cellAlign: "left",
                wrapAround: false,
                draggable: window.acf ? false : true,
                contain: true,
                pageDots: false,
                prevNextButtons: false,
                watchCSS: true,
                on: {
                    ready: () => {
                        setHeight(slider, equalHeightClass)
                    },
                    resize: () => {
                        setHeight(slider, equalHeightClass)
                    }
                },
            });

            if (window.acf) {
                setTimeout(() => {
                    card_flkty.resize();
                }, 500);
            }

            window.addEventListener("resize", () => {
                if (!window.acf) {
                    equalHeightClass.forEach((sliderItem) => {
                        sliderItem.style.height = "auto";
                    });
                }

                courses_flkty.resize()
            })
        });
    }

    if ($(".gallery-slider").length) {
        const sliders = document.querySelectorAll(".gallery-slider");


        const glsider = new Swiper('.gallery-slider', {
            slidesPerView:'auto',
            spaceBetween: 0,
            loop: false,
            centeredSlides: false,
            // breakpoints: {
            //     640: {
            //         slidesPerView: 1.65,
            //         spaceBetween: 20,
            //     },
            //     768: {
            //         slidesPerView: 1.85,
            //         spaceBetween: 24,
            //     },
            //     1020: {
            //         slidesPerView: 2.35,
            //         spaceBetween: 24,
            //     },
            //     1200: {
            //         slidesPerView: 2.45,
            //         spaceBetween: 24,
            //     },
            //     1536: {
            //         slidesPerView: 2.75,
            //         spaceBetween: 32,
            //     },
            // }
        });

        // sliders.forEach((slider) => {
        //     let courses_flkty = null,
        //         cardBody = slider.querySelectorAll(".wp-block-image"),
        //         equalHeightClass = null;

        //     if (!window.acf) equalHeightClass = slider.querySelectorAll(".wp-block-image");
        //     else {
        //         equalHeightClass = Array.from(slider.querySelectorAll(".wp-block-image")).map(
        //             (item) => item.parentElement
        //         );
        //     }

        //     if (cardBody && cardBody.length) equalHeights(cardBody);

        //     courses_flkty = new Flickity(slider, {
        //         cellAlign: "left",
        //         wrapAround: false,
        //         draggable: window.acf ? false : true,
        //         contain: true,
        //         pageDots: false,
        //         prevNextButtons: false,
        //         watchCSS: true,
        //     });

        //     courses_flkty.on("ready", () => {
        //         setHeight(slider, equalHeightClass);
        //     });

        //     courses_flkty.on("resize", () => {
        //         setHeight(slider, equalHeightClass);
        //     });

        //     if (window.acf) {
        //         setTimeout(() => {
        //             courses_flkty.resize();
        //         }, 1500);
        //     }

        //     window.addEventListener("resize", () => {
        //         if (!window.acf) {
        //             equalHeightClass.forEach((sliderItem) => {
        //                 sliderItem.style.height = "auto";
        //             });
        //         }

        //         courses_flkty.resize();
        //     });
        // });
    }
}